import styled from "styled-components";

export const ArrowsContainer = styled.div`
  position: fixed;
  right: 16px;
  bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1001;

  @media (max-width: 767px) {
    display: none; /* Solo tablet/desktop según requerimiento */
  }
`;

export const ArrowButton = styled.button`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--color-latex30);
  color: var(--color-white);
  cursor: pointer;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;

  svg {
    width: 18px;
    height: 18px;
  }

  &:hover {
    filter: brightness(0.95);
  }
`;
